<template>
  <div>
    <div class="mt-5">
      <wallet-amount
          :return_count="return_count"
          :current_balance="current_balance"
          :withdrawal_request_count="withdrawal_request_count"
      />
    </div>
    <!--  sechand filter section -->
    <v-row class="my-7">
      <v-col cols="7" md="6">
        <v-text-field
            v-model="withdrawal_serch_query"
            outlined
            rounded
            :placeholder="$lang.WITHDRAWAL_SERCH"
            dense
            @keyup="getWithdrawalList"
            append-icon="mdi-magnify"
            hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="3" md="2" class="text-right">
        <v-btn
            rounded
            depressed
            outlined
            class="download-svg-btn"
            width="151px"
            @click="downloadCsv"
        >
          <img src="@/assets/download.svg" alt=""/>
          {{ $lang.DOWNLOAD_CSV }}
        </v-btn>
      </v-col>
      <v-col md="2">
        <div
            @click="OpenFilterDialog"
            class="cursor-pointer w-max-content"
        >
          <filter-btn :filter_count="withdrawal_filter_data.filter_count"/>
        </div>
      </v-col>
    </v-row>

    <div class="my-4">
      <v-data-table
          :headers="headers"
          :items="withdrawal_history_list"
          :hide-default-footer="true"
          :disable-sort="true"
          class="elevation-1 custome-header-bg custome-table-body"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          show-select
          item-key="transaction_id"
          v-model="selected"
          :single-select="false"
      >
        <template v-slot:item.status="{ item }">
          <span :class="'transaction_' + item.status.toLowerCase()">{{
              item.status
            }}</span>
        </template>
        <template v-slot:item.created_date="{ item }">
          <p>{{ item.created_date }}</p>
          <p>{{ item.created_time }}</p>
        </template>
        <template v-slot:item.wholesaler="{ item }">
          <p>{{ item.firm_name }}</p>
          <p>{{ $lang.MOBILE_PREFIX }}{{ item.wholesaler_mobile_number }}</p>
        </template>
        <template v-slot:item.status="{ item }">
          <div class="text-right">
            <!--  accept withdrawal btn -->
            <v-btn
                outlined
                color="primary"
                @click="show_dialog(item)"
                class="br-8 border-w-2"
                v-if="item.status == 'Processing'"
            >
              <b>{{ $lang.WITHDRAW }}</b>
            </v-btn>

            <span
                v-if="item.status != 'Processing'"
                :class="'transaction_' + item.status.toLowerCase()"
            >{{ item.status }}</span
            >
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <!-- go to transation details -->
          <v-btn
              small
              fab
              text
              @click="gotoWidthdrwalDetails(item.transaction_id)"
          >
            <img src="../../assets/arrow-right.svg" alt=""/>
          </v-btn>
        </template>
        <!--  empty state  -->
        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_TRANSACTION"/>
        </template>
      </v-data-table>

      <v-pagination
          class="custome-pagination"
          v-model="page_number"
          :total-visible="7"
          :length="total_page_count"
          @input="getWithdrawalList"
      ></v-pagination>
    </div>

    <withdrawal-filter
        :filter_data="filter_data"
        @filter="getWithdrawalList"
        :filter_dialog="filter_dialog"
        ref="withdrawal_filter_dialog"

    />
    <withdraw-verification-dailog
        :dialog="dialog"
        @update-list="getWithdrawalList"
    />
  </div>
</template>

<script type="text/javascript">
import {mapGetters} from 'vuex';


export default {
  components: {
    WalletAmount: () => import("./child/WalletAmount.vue"),
    WithdrawalFilter: () => import("./child/WithdrawalFilter.vue"),
    WithdrawVerificationDailog: () =>
        import("./child/WithdrawVerificationDailog.vue"),
    FilterBtn: () => import("@/components/common-components/FilterBtn.vue"),
  },
  data() {
    return {
      withdrawal_serch_query: "",
      return_count: 0,
      current_balance: 0,
      withdrawal_request_count: 0,
      withdrawal_history_list: [],
      transaction_id_list: [],
      selected: [],
      filter_data: {
        wholesaler_id_list: [],
        filter_date_from: "",
        filter_date_to: "",
        filter_count: 0,
      },

      dialog: {
        flag: false,
        item: "",
      },
      filter_dialog: {
        flag: false,
      },

      /* Table Elements */
      page_number: 1,
      table_loading: false,
      total_page_count: 1,
      headers: [
        {
          text: "#Transaction ID",
          align: "start",
          sortable: false,
          value: "transaction_id",
        },
        {text: "Date & Time", value: "created_date"},
        {text: "Wholesaler Info", value: "wholesaler"},
        {text: "Amount", value: "amount"},
        {text: "Returns", value: "shipment_count"},
        {text: "", value: "status"},
        {text: "", value: "action"},
      ],
    };
  },
  computed: mapGetters({
    withdrawal_filter_data: "withdrawal/getWithdrawalFilter",
  }),
  created() {
    this.$store.dispatch("setPageLoader", true);
    this.getWithdrawalList(false);
  },
  methods: {
    /* get ithdrawal list */
    getWithdrawalList(is_cancel = true) {
      const self = this;
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.withdrawal_serch_query,
        filter_date_from: this.withdrawal_filter_data.filter_date_from,
        filter_date_to: this.withdrawal_filter_data.filter_date_to,
        wholesaler_id_list: JSON.stringify(this.withdrawal_filter_data.wholesaler_id_list),
      };
      self.table_loading = true;

      const successHandler = (response) => {
        console.log(response);
        if (response.data.success) {
          this.withdrawal_history_list = response.data.withdrawal_history_list;
          this.total_page_count = response.data.total_page_count;
          this.current_balance = response.data.amount;
          this.return_count = response.data.returned_count;
          if (response.data.withdrawal_request_count)
            this.withdrawal_request_count =
                response.data.withdrawal_request_count;
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };

      self.request_GET(
          self,
          self.$urls.WITHDRAWAL_HISTORY,
          params,
          successHandler,
          null,
          null,
          finallyHandler,
          is_cancel
      );
    },
    gotoWidthdrwalDetails(transaction_id) {
      console.log(transaction_id);
      this.$router.push({
        name: "withdrawal--details",
        params: {transaction_id: this.encript(transaction_id)},
      });
    },
    /* open dialog */
    show_dialog(item) {
      this.dialog.item = item;
      this.dialog.flag = true;
    },
    /* get transaction id  list  for selected transaction */
    getTransactionIdList() {
      this.transaction_id_list = [];
      for (let i = 0; i < this.selected.length; i++) {
        this.transaction_id_list.push(this.selected[i].transaction_id);
      }
      this.transaction_id_list = JSON.stringify(this.transaction_id_list);
    },
    /* Download Csv*/
    downloadCsv() {
      if (this.selected.length == 0) {
        this.showSnakeBar("warning", this.$messages.NO_TRANSACTION_SELECTED);
        return false;
      }
      this.transaction_id_list = [];
      for (let i = 0; i < this.selected.length; i++) {
        this.transaction_id_list.push(this.selected[i].transaction_id);
      }
      this.transaction_id_list = JSON.stringify(this.transaction_id_list);

      window.open(
          this.$urls.BASE_URL +
          this.$urls.WITHDRAW_CSV +
          "?withdrawal_id_list=" +
          this.transaction_id_list,
          "_blank"
      );
    },
    /* open filter dialog */
    OpenFilterDialog() {
      this.filter_data.wholesaler_id_list = this.withdrawal_filter_data.wholesaler_id_list
      this.filter_data.filter_date_from = this.withdrawal_filter_data.filter_date_from
      this.filter_data.filter_date_to = this.withdrawal_filter_data.filter_date_to
      this.filter_data.filter_data = this.withdrawal_filter_data.filter_data
      this.filter_dialog.flag = true

    },


  },
};
</script>